import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import t from '@instructure/quiz-i18n/format-message';
import reduxStore from '../../reduxStore';
export var MAX_SETTIMEOUT_IN_MILLISECONDS = 20 * 24 * 3600 * 1000; // ms of 20 days
export var TimerService = /*#__PURE__*/function () {
  function TimerService(getTimeRemaining, updateTimeRemaining, getTimerData, submitQuiz, alert, setWsToken) {
    var _this = this;
    _classCallCheck(this, TimerService);
    _defineProperty(this, "__performApiCall", function () {
      _this._getTimeRemaining(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (_this._stopped) {
          return;
        }
        _this.__resetClockInterval(data.timerRunning && data.timeLeftInSeconds >= 0);
        _this.__onTimerChange(data);
        _this.__setApiCallIntervalTime(data.timeLeftInSeconds);
        if (_this._setWsToken) {
          _this._setWsToken(data.wsToken);
        }
      });
    });
    this._getTimeRemaining = getTimeRemaining;
    this._updateTimeRemaining = updateTimeRemaining;
    this._getTimerData = getTimerData;
    this._submitQuiz = submitQuiz;
    this._alert = alert;
    this._setWsToken = setWsToken;
    this._stopped = false;
    this._apiInterval = null;
    this._clockInterval = null;
    this._apiTimeIncrement = 10000;
    this._clockTimeIncrement = 1000;
  }
  return _createClass(TimerService, [{
    key: "start",
    value: function start() {
      this.__performApiCall();
      this.__startApiInterval();
      return this;
    }
  }, {
    key: "stop",
    value: function stop() {
      this._stopped = true;
      this.__stopApiInterval();
      this.__stopClockInterval();
      return this;
    }
  }, {
    key: "__ensureNotStopped",
    value: function __ensureNotStopped() {
      if (this._stopped) {
        throw new Error('An attempt was made to restart a stopped timer. This is disallowed ' + 'to prevent tricky race conditions. Create a new TimerService object instead.');
      }
    }
  }, {
    key: "__startApiInterval",
    value: function __startApiInterval() {
      this.__ensureNotStopped();
      this._apiInterval = setInterval(this.__performApiCall, this._apiTimeIncrement);
    }
  }, {
    key: "__stopApiInterval",
    value: function __stopApiInterval() {
      clearInterval(this._apiInterval);
      this._apiInterval = null;
    }
  }, {
    key: "__resetApiCallInterval",
    value: function __resetApiCallInterval() {
      this.__stopApiInterval();
      this.__startApiInterval();
    }
  }, {
    key: "__setApiCallIntervalTime",
    value: function __setApiCallIntervalTime(timeLeftInSeconds) {
      var startIncrement = this._apiTimeIncrement;
      var newIncrement = this.__nextIncrement(timeLeftInSeconds);
      if (startIncrement !== newIncrement) {
        this._apiTimeIncrement = newIncrement;
        this.__resetApiCallInterval();
      }
    }
  }, {
    key: "__nextIncrement",
    value: function __nextIncrement(timeLeftInSeconds) {
      if (Number.isNaN(timeLeftInSeconds - 0)) {
        return 30000;
      }
      if (timeLeftInSeconds < 180) {
        return 15000;
      } else if (timeLeftInSeconds < 7200) {
        return 150000;
      }
      var interval = Math.max(15000, Math.floor(timeLeftInSeconds * 500)); // timeLeft/2
      return Math.min(interval, MAX_SETTIMEOUT_IN_MILLISECONDS);
    }
  }, {
    key: "__startClockInterval",
    value: function __startClockInterval() {
      var _this2 = this;
      this.__ensureNotStopped();
      var action = function action() {
        var state = reduxStore.getAppState();
        var _this2$_getTimerData$ = _this2._getTimerData(state).toJS(),
          timerRunning = _this2$_getTimerData$.timerRunning,
          timeLeftInSeconds = _this2$_getTimerData$.timeLeftInSeconds;
        if (!timerRunning || timeLeftInSeconds !== 0 && !timeLeftInSeconds) {
          return;
        }
        var delta = Math.round(_this2._clockTimeIncrement / 1000);
        var newTimeLeftInSeconds = timeLeftInSeconds - delta;
        _this2.__onTimerChange({
          timerRunning: timerRunning,
          timeLeftInSeconds: newTimeLeftInSeconds
        });
      };
      this._clockInterval = setInterval(action, this._clockTimeIncrement);
    }
  }, {
    key: "__stopClockInterval",
    value: function __stopClockInterval() {
      clearInterval(this._clockInterval);
      this._clockInterval = null;
    }
  }, {
    key: "__resetClockInterval",
    value: function __resetClockInterval() {
      var startClock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.__stopClockInterval();
      if (startClock) {
        this.__startClockInterval();
      }
    }
  }, {
    key: "__onTimerChange",
    value: function __onTimerChange(_ref) {
      var timerRunning = _ref.timerRunning,
        timeLeftInSeconds = _ref.timeLeftInSeconds;
      var state = reduxStore.getAppState();
      var prevTimerData = this._getTimerData(state);
      this._updateTimeRemaining({
        timerRunning: timerRunning,
        timeLeftInSeconds: timeLeftInSeconds
      });
      if (prevTimerData.get('timeLeftInSeconds') > 120 && timeLeftInSeconds <= 120) {
        this._alert(t('You have less than 2 minutes remaining.'));
      }
      if (prevTimerData.get('timeLeftInSeconds') > 30 && timeLeftInSeconds <= 30) {
        this._alert(t('You have less than 30 seconds remaining.'));
      }
      if (timeLeftInSeconds !== null && timeLeftInSeconds <= 0) {
        this.stop();
        this._submitQuiz();
      }
    }
  }]);
}();
export default TimerService;